import { useNavigate } from "react-router-dom";
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ModalDialog } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {useState, useContext} from 'react';
import { getDbBackupData } from "../../services/dbbackupServices";
import { ThemeContext } from "../../layout/BaseLayout";
import { Loader } from "../../utils/loader";

const dbBackupModal = (props: any) => {
  return (
     <Draggable handle=".modal-header">
        <ModalDialog {...props} />
     </Draggable>
  );
};

export default function Header() {
  let toast : any = useContext(ThemeContext);
  const [showDbBackupModal, setShowDbBackupModal] = useState(false);
  const [disabledCancelBtn, setDisabledCancelBtn] = useState(false);

  const reloadPage = () => {
    window.location.reload();
  };

  const isLogintoken: any = sessionStorage.getItem("token");
  const isuserAuthData: any = sessionStorage.getItem("userAuthData");
  const username = JSON.parse(isuserAuthData)?.sub;
  let navigate = useNavigate();

  const logout = () => {
    window.sessionStorage.removeItem("token");
    window.sessionStorage.removeItem("userAuthData");
    window.sessionStorage.removeItem("timezone");
    navigate('/');
    window.location.href = '/';
  };

  const loginConnect = () => {
    // reloadPage();
    // navigate('/');
    window.location.href = "/";
  }

  const privacyPolicy = () => {
    navigate('/privacypolicy');
  }

  const startBackup = () => {
    setDisabledCancelBtn(true);
    getDbBackupData().then((res:any) => {
      setDisabledCancelBtn(false);
      if (res.isSuccess) {
        setDisabledCancelBtn(false);
        setShowDbBackupModal(false);
        toast.success(res.successMessage);
      }else {
        setDisabledCancelBtn(false);
      }
    }).catch(e => {
      setDisabledCancelBtn(false);
    })
  }

  const startDataBackup = () => {
    setShowDbBackupModal(true);
  }

  const closeDbBackupModal = () => {
    setShowDbBackupModal(false);
  }

  return (
    <>
      <div className="page-menu">
        <div className="d-none">
          <nav id="primary_nav_wrap" >
            <ul>
              <li className="current-menu-item">
                <a href="#">File</a>
                <ul>
                  <li>
                    <a href="#">Sub Menu 1</a>
                  </li>
                  <li>
                    <a href="#">Sub Menu 2</a>
                  </li>
                  <li>
                    <a href="#">Sub Menu 3</a>
                  </li>
                  <li>
                    <a href="#">Sub Menu 4</a>
                    <ul>
                      <li>
                        <a href="#">Deep Menu 1</a>
                        <ul>
                          <li>
                            <a href="#">Sub Deep 1</a>
                          </li>
                          <li>
                            <a href="#">Sub Deep 2</a>
                          </li>
                          <li>
                            <a href="#">Sub Deep 3</a>
                          </li>
                          <li>
                            <a href="#">Sub Deep 4</a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="#">Deep Menu 2</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="#">Sub Menu 5</a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#">Edit</a>
              </li>
              <li>
                <a href="#">View</a>
              </li>
              <li>
                <a href="#">Service</a>
              </li>
              <li>
                <a href="#">Help</a>
              </li>
            </ul>
          </nav>
          <div className="text-right mr-1 ">
            <img src={"/images/svg/user.svg"} className="logo mr-1" alt="" />
            <span className="mr-2 username">{username}</span>
            {/* <span className="mr-1">MetaTrader 5</span>
            <span>Administrator</span> */}
          </div>
        </div>
        <div className="header-menubox">
          <ul>
            {!!isLogintoken && !!isuserAuthData ? (
              <>
                <li className="iconimg" onClick={() => logout()}>
                  <a>
                    <img
                      src={"/images/svg/disconnected.svg"}
                      alt="" />
                    Disconnect
                  </a>
                </li>
                <li><span className="header-line">&nbsp;</span></li>
                <li className="iconimg" onClick={() => navigate('/changepassword')}>
                  <a>
                    <img
                      src={"/images/svg/change-password.svg"}
                      alt=""
                    />
                    Change Password
                  </a>
                </li>
                <li><span className="header-line">&nbsp;</span></li>
                <li className="iconimg" onClick={() => startDataBackup()}>
                  <a>
                    <img
                      src={"/images/svg/data-sync.svg"}
                      alt=""
                    />
                    DB Backup
                  </a>
                </li>
                {/* <li><span className="header-line">&nbsp;</span></li>
                <li className="iconimg">
                  <a href="">
                    <img src={"/images/svg/restart.svg"} alt="" />
                    Restart Server
                  </a>
                </li>
                <li><span className="header-line">&nbsp;</span></li>
                <li className="iconimg">
                  <span className="remove_arrow_summary" onClick={() => navigate("/data-sync")}>
                    <img src={"/images/svg/data-sync.svg"} alt="" />
                    Data Sync
                  </span>
                </li> */}
              </>
            ) : (
              <>
              {window.location.pathname !== '/privacypolicy' && 
              <>
              <li className="iconimg" onClick={() => loginConnect()}>
                <a>
                  <img src={"/images/svg/connected.svg"} alt="" />
                  Connect
                </a>
              </li>
              <li><span className="header-line">&nbsp;</span></li>
              </>
            }
              <li className="iconimg" onClick={() => privacyPolicy()}>
                <a>
                  {/* <img src={"/images/svg/connected.svg"} alt="" /> */}
                  Privacy Policy
                </a>
              </li>

              </>
            )}

            {/* <li>
              <span className="header-line">&nbsp;</span>
              <img
                src={require("../../images/icon/line.png")}
                className="mx-2"
                alt=""
              />
            </li> */}
            {/* <li className="iconimg">
              <a href="">
                <img src={require("../../images/icon/menu/leftarrow.png")} />
              </a>
            </li>
            <li className="iconimg">
              <a href="">
                <img src={require("../../images/icon/menu/rightarrow.png")} />
              </a>
            </li>
            <li>
              <img
                src={require("../../images/icon/line.png")}
                className="mx-2"
              />
            </li>
            <li className="iconimg">
              <a onClick={reloadPage}>
                <img src={require("../../images/icon/menu/refresh.png")} />
                Refresh
              </a>
            </li> */}
            {/* <li>
              <img
                src={require("../../images/icon/line.png")}
                className="mx-2"
              />
            </li>
            <li className="iconimg">
              <a href="">
                <img src={require("../../images/icon/menu/add.png")} />
              </a>
            </li>
            <li className="iconimg">
              <a href="">
                <img src={require("../../images/icon/menu/edit.png")} />
              </a>
            </li>
            <li className="iconimg">
              <a href="">
                <img src={require("../../images/icon/menu/delete.png")} />
              </a>
            </li> */}
          </ul>
          <div className="text-right mr-1 d-inline-block float-end ">
            <img src={"/images/svg/user.svg"} className="logo mr-1" alt="" />
            <span className="mr-2 username">{username}</span>
            {/* <span className="mr-1">MetaTrader 5</span>
            <span>Administrator</span> */}
          </div>
        </div>
      </div>
      <div className="login-popup">
            <Modal
               className="login feed-modules"
               show={showDbBackupModal}
               onHide={() => { closeDbBackupModal() }}
               backdrop="static"
               dialogAs={dbBackupModal}
               animation={false}
              //  size="md"
               centered
            >
               <Modal.Header closeButton style={{ border: "none" }}>
                  <Modal.Title className="w-100"> DataBase Backup
                     <div className="btn-help d-inline-block float-right ">
                        {/* <i className="fa-question fa-solid font-size-16 mt-1"></i> */}
                     </div>
                  </Modal.Title>
               </Modal.Header>
               <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
               {disabledCancelBtn && <Loader/>}
                  <div className="fidderbox-inner office-feed-height dbbackup">
                     <div>
                        This functionality will take the database backup & store in your server.
                     </div>
                     <div className="w-100 text-center mt-4"><button className="btn addnewbtn mb-0 ml-2" onClick={() => startBackup()}>Start Backup</button></div>
                  </div>
               </Modal.Body>
               <Modal.Footer>
                  <div>
                     <div className="w-100 text-right p-1">
                        {/* <Button className="btnmain mr-3" onClick={() => {  }}>
                           {!!isEdit ? "Update" : "Submit"}
                        </Button> */}
                        <Button onClick={() => { closeDbBackupModal() }} className="btnmain-danger" disabled={disabledCancelBtn ? true : false}>
                           Cancel
                        </Button>
                     </div>
                  </div>
               </Modal.Footer>
            </Modal>
         </div>
    </>
  );
}
